import { updateAnalyticsEventAttribute } from '@process-advisor/process-miner/processMiner/processMiner';

export type AnalyticEventAttributeProps = {
    attribute?: string;
}

export const changeAnalyticsEventAttribute = ({
    attribute,
}: AnalyticEventAttributeProps) => updateAnalyticsEventAttribute({
    attribute,
});
